import React from 'react';
import { prop } from 'ramda';

import { componentService } from '@core/js/services/component.service';
import { useAppSelector } from '@core/js/store/hooks';

import { clsx } from '@interlayer/js/app/utils/clsx.util';

import { TSvgIconProps } from './types';

import defaultStyle from './SvgIcon.scss';

export const SvgIcon: React.FC<TSvgIconProps> = ({ type, height, width, className, color = '', onClick, style = {}, ...other }) => {
    const themeName = useAppSelector(prop('themeName'));
    const checkColor = () => {
        if (!color) {
            return '';
        }

        return color.startsWith('#') ? color : `var(--${color})`;
    };

    return (
        <svg
            data-testid={`SvgIcon_icon ${type}`}
            className={clsx(defaultStyle.icon, className)}
            color={checkColor()}
            fill="currentColor"
            style={{ ...style, width, height }}
            {...onClick && { onClick }}
            {...other}
        >
            <use height="100%" width="100%" xlinkHref={`/${themeName}/js/app-out/img/styles__assets__icons__${type}.svg#${type}`} />
        </svg>
    );
};

componentService.registerWebContentComponents({ SvgIcon });
